import { render, staticRenderFns } from "./privacy-requests-filter.vue?vue&type=template&id=ef40a944&"
import script from "./privacy-requests-filter.vue?vue&type=script&lang=ts&"
export * from "./privacy-requests-filter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports